/**
 * Phoenix seatmap channel push payloads (legacy BookingBus contract).
 */

import { isFlightRecorderEnabled, recordFlightEvent } from '../debug/flightRecorder'
import { getCurrentFlowSpanId } from '../debug/flightCorrelation'

/**
 * @param {{ seatId: string, sectionId: string, col: number, row: number }} seat
 * @param {{ legFrom: number|string, legTo: number|string, name: string }} segment
 * @param {number} [ttlSec=300]
 */
export function buildSeatChannelPayload (seat, segment, ttlSec = 300) {
  return {
    seat: {
      leg_from: String(segment.legFrom),
      leg_to: String(segment.legTo),
      seat_id: seat.seatId,
      seat: {
        col: seat.col,
        row: seat.row,
        scheduleId: segment.name,
        sectionId: seat.sectionId,
      },
    },
    ttl_sec: ttlSec,
  }
}

function recordWsPush (event, seat) {
  if (!isFlightRecorderEnabled()) return
  recordFlightEvent(
    'WS:PUSH',
    {
      event,
      direction: 'out',
      seatId: seat?.seatId,
      label: seat?.label ?? seat?.rowLabel,
      flowSpanId: getCurrentFlowSpanId() || undefined,
    },
    'seatmapPush',
  )
}

/**
 * @param {{ push: Function }|null|undefined} channel
 * @param {object} seat
 * @param {object} segment
 * @returns {boolean}
 */
export function pushSeatSelected (channel, seat, segment) {
  if (!channel || typeof channel.push !== 'function') return false
  channel.push('seat:selected', buildSeatChannelPayload(seat, segment))
  recordWsPush('seat:selected', seat)
  return true
}

/**
 * @param {{ push: Function }|null|undefined} channel
 * @param {object} seat
 * @param {object} segment
 * @returns {boolean}
 */
export function pushSeatUnselected (channel, seat, segment) {
  if (!channel || typeof channel.push !== 'function') return false
  channel.push('seat:unselected', buildSeatChannelPayload(seat, segment))
  recordWsPush('seat:unselected', seat)
  return true
}
